// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getFormQuestions } from '@lyon/utils/api/forms';

interface IProps {
  id: string;
}

export const FormQuestionsData = createModel(({ id }: IProps) => {
  const response = useSWR(
    `/forms/${id}/questions`,
    () => getFormQuestions({ id }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const { data } = response;

  const orderedQuestions = data?.shuffleQuestion
    ? data.questions.slice().sort(() => Math.random() - 0.5)
    : data?.questions;

  return {
    ...response,
    orderedQuestions,
  };
}, {
  displayName: 'Models.FormQuestionsData',
});

export const useFormQuestionsData = createSelector(
  FormQuestionsData,
  ({ data }) => data?.questions,
);

export const useFormQuestionsDataOrdered = createSelector(
  FormQuestionsData,
  ({ orderedQuestions }) => orderedQuestions,
);

export const useFormQuestionsMutate = createSelector(
  FormQuestionsData,
  ({ mutate }) => mutate,
);
